<template>
  <v-container>
    <h2>Profile</h2>
    <p></p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="admin.firstname"
              label="Firstname"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="admin.lastname"
              label="Lastname"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="admin.email"
              label="Email"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="admin.phone_number"
              label="Phone number"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="admin.line_id"
              label="Line ID"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-btn
          small
          text
          color="primary"
          :to="{ name: 'profile-password' }"
        >
          Update password
        </v-btn>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateAdminProfile"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            @click="$router.go(-1)"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers'
export default {
  name: 'ProfileEdit',
  data: () => ({
    admin_id: null,
    admin: {
      firstname: null,
      lastname: null,
      username: null,
      email: null,
      phone_number: null,
      line_id: null,
      profile_image_url: null
    },
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  async mounted () {
    await this.getAdminDetail()
  },
  methods: {
    async getAdminDetail () {
      try {
        const { data } = await this.$http.get(`/back-office/user`, authHeader())
        this.admin.firstname = data.user.firstname
        this.admin.lastname = data.user.lastname
        this.admin.username = data.user.username
        this.admin.email = data.user.email
        this.admin.phone_number = data.user.phone_number
        this.admin.line_id = data.user.line_id
        this.admin_id = data.user.id
        
      } catch (err) {
        if (err.response)
          alert(err.response.data.message)
        else {
          console.log(err)
          alert('Something went wrong.')
        }
      }
    },
    async updateAdminProfile () {
      try {
        await this.$http.put(`/back-office/user`, this.admin, authHeader())
        alert('Done!')
      } catch (err) {
        if (err.response)
          alert(err.response.data.message)
        else {
          console.log(err)
          alert('Something went wrong.')
        }
      }
    }
  }
}
</script>